import React, { useContext, useState, useMemo, useEffect } from "react";
import sistemaListStore, { sistemaListShowModal } from "../SistemaList/ThisMainComponent/thisStore";
import { IsFunction } from "~/utils/CheckDataType";
import { useSelector } from "react-redux";
import { ThisButton } from "./styles";

function Button({
  children,
  linhaAtiva,
  setLinhaAtiva,
  id,
  data,
  noEdit,
  noDelete,
  noRestore,
  onClick,
  setType,
  ...rest
}) {
  const moldalType = "edit";
  const { state, dispatch } = useContext(sistemaListStore);
  const { show, create, edit, destroy, filter } = state?.modal || {};
  const { findOne } = state?.requests || {};
  const [active, setActive] = useState();
  const { ativo: reduxConfirm } = useSelector((state) => state?.confirmacaoModal || {});

  useEffect(() => {
    if (!reduxConfirm && destroy && !active) {
      dispatch(sistemaListShowModal(false));
    }
  }, [reduxConfirm, destroy, dispatch, active]);

  const checkModal = useMemo(() => {
    return show || create || edit || destroy || filter;
  }, [create, destroy, edit, show, filter]);

  useEffect(() => {
    if (!checkModal && !!active) {
      dispatch(sistemaListShowModal({ [moldalType]: true }, active));
      onClick && onClick();
      setActive();
    }
  }, [active, checkModal, dispatch, moldalType, onClick]);


  return <ThisButton {...{ ...rest }}
    onClick={async () => {
      setLinhaAtiva(id);
      
      // if (!noEdit && linhaAtiva === id) {
      if (!noEdit) {
        let entityData = moldalType && data;

        if (entityData && IsFunction(findOne)) {
          await findOne(data)
            .then((resp) => resp?.data && (entityData = resp.data))
            .catch(() => { });
        }
        if (checkModal) {
          setActive(entityData || true);
        } else {
          setActive();
          dispatch(sistemaListShowModal({ [moldalType]: true, editShow: true }, entityData, { noEdit, noDelete, noRestore }));

          onClick && onClick();
        }
      }
    }}
    title="Clique duas vezes para editar o item"
  >
    {children}
  </ThisButton>;
}

export default Button;
